import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { dashboardPathFor } from "@/lib/roles";

/** Smart redirect after login (email or Google). Routes user by primary_role. */
export default function PostLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/login", { replace: true }); return; }
    navigate(dashboardPathFor(user.primary_role), { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="post-login-loading">
      <div className="label-tiny text-text-secondary">SIGNING YOU IN...</div>
    </div>
  );
}
